<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">短信宝</div>
      <el-form-item label="账户">
        <el-input v-model="form.username" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="form.password" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="短信签名">
        <el-input v-model="form.sign" class="max-w460"></el-input>
      </el-form-item>
      <!-- <div class="common-form">短信模板</div>
      <el-form-item label="注册短信模板">
        <el-input v-model="form.login_template" class="max-w460"></el-input>
        <div class="tips">
          不填则表示不支持h5登录
        </div>
      </el-form-item>
      <el-form-item label="商户申请短信模板">
        <el-input v-model="form.apply_template" class="max-w460"></el-input>
        <div class="tips">
          如果不开启手机验证可以不用填写
        </div>
      </el-form-item>
      <el-form-item label="商户审核未通过短信模板">
        <el-input v-model="form.supplier_reject_code" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户审核通过短信模板">
        <el-input v-model="form.supplier_pass_code" class="max-w460"></el-input>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        default: "smsbao",
        username: "",
        password: "",
        sign: ""
        // AccessKeyId: "",
        // AccessKeySecret: "",
        // sign: "",
        // accept_phone: "",
        // login_template: "",
        // apply_template: "",
        // supplier_reject_code: "",
        // supplier_pass_code: ""
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

//   "engine": {
// "aliyun": [],
// "smsbao": {
// "username": "ruanchengkeji",
// "password": "517ac9bbea3c42fd89677a82d2a7cbce",
// "sign": "软程科技"
// }
// }
  methods: {
    getData() {
      let self = this;
      SettingApi.smsDetail({}, true)
        .then(data => {
          self.form= data.data.engine.smsbao
          // console.log(self.form.engine.smsbao)
          
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editSms({
        engine: {
          aliyun: [],
          smsbao: params
        }
      }, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，短信通知设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    //发送短信
    sendOut() {
      let self = this;
      let params = this.form;
      SettingApi.sendSms(params, true)
        .then(data => {
          self.$message({
            message: "恭喜你，短信发送成功",
            type: "success"
          });
          self.$router.push("/setting/Sms");
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/sms/index.vue